import { render, staticRenderFns } from "./SystemDictionaryEdit.vue?vue&type=template&id=a7930db0&"
import script from "./SystemDictionaryEdit.vue?vue&type=script&lang=js&"
export * from "./SystemDictionaryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports